@import '@hevoio/hevo-ui-toolkit/styles/variables';

.paneContainer {
  border: solid $border-width $divider-color;
  border-radius: $border-radius-md;
  display: flex;
  flex-direction: column;
  margin-bottom: $spacer * 2;
}

.pipelineScheduleHeader {
  border-bottom: solid $border-width $divider-color;
  padding: $spacer * 0.75 $spacer * 1.25;
  display: flex;
  align-items: center;
}

.scheduleContainer {
  padding: $spacer * 1.25;
  display: flex;
  flex-direction: column;
}

.pipelineSchedulerOptions {
  margin: $spacer * 1.25 0 0 0;
  & button {
    background: var(--calendly-surface-bg);
    border: $border-width solid $divider-color;
  }
}

.contactSalesCTA {
  max-width: 120px;
  margin-top: $spacer;
}
